<!--  -->
<template>
  <div class="addviar">
    <template>
      <el-table
        border
        :data="QRcodelist"
        style="width: 100%"
      >
        <el-table-column
          prop="config_id"
          label="配置id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="qr_code"
          label="二维码"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <img v-if="scope.row.avatar!==''" :src="scope.row.avatar" alt="" style="width:80px;height:80px"> -->
            <!-- <el-avatar :size="50" :src="scope.row.avatar">
              <img :src="QRcodelist.qr_code">
            </el-avatar> -->
            <!-- <el-image
            style="width: 100px; height: 100px"
            :src="QRcodelist[index+1].qr_code"
            :preview-src-list="QRcodelist.qr_code"
          /> -->
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.qr_code"
            />
            <!-- <div
              v-for="(img) in ([scope.row.qr_code])"
              :key="img.id"
            >
              <a
                :href="img"
                download
              />
              <el-image
                style="width: 100px; height: 100px"
                :src="img"
                :preview-src-list="srcList"
                lazy
                @click="clickImage"
              />
            </div> -->

          </template>
        </el-table-column>
        <el-table-column
          prop="channel_type"
          label="自定义参数"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-for="(img) in ([scope.row.qr_code])"
              :key="img.id"
            >
              <el-button
                type="primary"
                size="mini"
                style="margin-bottom:10px"
                @click="choose(scope.row)"
              >选择</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <pagination-right
      :current-page="pages.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- <el-dialog
      title="创建"
      :visible.sync="addQRcodeshow"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <qirdialog
        ref="qirdialogview"
        @updata="updata"
      ></qirdialog>
    </el-dialog> -->
  </div>
</template>

<script>
// import qirdialog from './components/qirdialog.vue'
import { spWorkWechatSpCorpUserQrcode } from '@/api/QRcode'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { /* qirdialog */ PaginationRight },
  data() {
    return {
      addQRcodeshow: false,
      QRcodelist: [],
      pages: {
        page: 1,
        page_size: 10
      },
      total: 0
    }
  },
  created() {
    this.getQRcodelist()
  },
  computed: {
    srcList() {
      return this.QRcodelist.map(item => item.qr_code)
    }
  },
  mounted() {},
  methods: {
    addQRCode() {
      this.addQRcodeshow = true
    },
    async getQRcodelist() {
      const res = await spWorkWechatSpCorpUserQrcode({
        // corp_user_id: this.ids.corp_user_id,
        ...this.pages
      })
      this.total = res.data.total
      this.QRcodelist = res.data.list
    },
    fetchPageSize(e) {
      this.pages.page_size = e
      this.getQRcodelist()
    },
    fetchCurrentPage(e) {
      this.pages.page = e
      this.getQRcodelist()
    },
    updata() {
      this.addQRcodeshow = false
      this.getQRcodelist()
    },
    // 下载图片,预览里的
    clickImage() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })

      this.$nextTick(() => {
        const wrapper = document.getElementsByClassName('el-image-viewer__actions__inner')
        const downImg = document.createElement('i')
        downImg.setAttribute('class', 'el-icon-download')
        wrapper[0].appendChild(downImg)
        if (wrapper.length > 0) {
          this.wrapperElem = wrapper[0]
          this.cusClickHandler()
        }
      })
    },
    choose(item) {
      this.$emit('callbackerweima', item)
    },
    send() {
      this.getQRcodelist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.addviar {
  padding: 30px;
}
</style>